import { CLIENTS_ROW_A, CLIENTS_ROW_B, INDUSTRIES } from "../lib/data";

function Chip({ name }) {
  return (
    <div className="group mx-3 shrink-0 flex items-center rounded-full border border-white/10 bg-[var(--bg-secondary)] px-7 py-4 transition-colors hover:border-[var(--accent-primary)]/60">
      <span className="font-display text-lg md:text-xl font-semibold text-zinc-500 group-hover:text-white transition-colors whitespace-nowrap">
        {name}
      </span>
    </div>
  );
}

function Row({ items, direction }) {
  const doubled = [...items, ...items];
  return (
    <div className="flex w-full overflow-hidden">
      <div
        className={`marquee-track flex w-max ${
          direction === "left" ? "animate-marquee-left" : "animate-marquee-right"
        }`}
      >
        {doubled.map((name, i) => (
          <Chip key={`${name}-${i}`} name={name} />
        ))}
      </div>
    </div>
  );
}

export default function Clients() {
  return (
    <section
      id="clients"
      data-testid="clients-section"
      className="relative py-24 md:py-32 bg-[var(--bg-primary)] overflow-hidden"
    >
      <div className="px-6 md:px-12 lg:px-16 mb-14 md:mb-20 max-w-4xl">
        <p className="text-xs md:text-sm font-bold uppercase tracking-[0.25em] text-[var(--accent-primary)]">
          05 — Some of
        </p>
        <h2 className="mt-5 font-display text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight leading-[1.02] text-white">
          Our clients
        </h2>
        <p className="mt-6 text-base md:text-lg text-zinc-400 max-w-2xl">
          Trusted across FMCG, retail, real estate, education, technology,
          hospitality, healthcare, automotive and fintech.
        </p>
      </div>

      <div className="flex flex-col gap-5">
        <Row items={CLIENTS_ROW_A} direction="left" />
        <Row items={CLIENTS_ROW_B} direction="right" />
      </div>

      <div className="px-6 md:px-12 lg:px-16 mt-16 flex flex-wrap gap-3">
        {INDUSTRIES.map((ind) => (
          <span
            key={ind}
            className="rounded-full border border-white/10 px-4 py-2 text-xs font-medium uppercase tracking-wider text-zinc-500"
          >
            {ind}
          </span>
        ))}
      </div>
    </section>
  );
}
